/* Implementation of the Dracula theme for VS Code
Original: https://github.com/dracula/visual-studio-code */

.prism-code-editor {
	font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
	--pce-cursor: #aeafad;
	--pce-bg: #282a36;
	--pce-widget-border: #454545;
	--pce-widget-bg: #21222c;
	--pce-widget-color: #f8f8f2;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #b2b2a8;
	--pce-widget-bg-input: #282a36;
	--pce-widget-bg-hover: #5a5d5e80;
	--pce-widget-bg-active: #6272a466;
	--pce-widget-focus: #bd93f9;
	--pce-search-match: #ffffff40;
	--pce-widget-bg-error: #5a1d1d;
	--pce-widget-error: #ff5555;
	--pce-border-highlight: 2px solid #44475a;
	--pce-selection-match: #424450;
	--pce-line-number: #6272a4;
	--pce-scrollbar: 0, 0%, 50%;
	--pce-bg-fold: #c5c5c5;
	--pce-guide-indent: #ffffff1a;
	--pce-ac-icon-class: #ee9d28;
	--pce-ac-icon-enum: #ee9d28;
	--pce-ac-icon-event: #ee9d28;
	--pce-ac-icon-function: #b180d7;
	--pce-ac-icon-interface: #75beff;
	--pce-ac-icon-variable: #75beff;
	--pce-selection: #44475a;
	color-scheme: dark;
}

.match-highlight {
	--pce-bg-highlight: #44475a;
}

.pce-match {
	--pce-search-match: #ffb86c80;
}

.active-line {
	--pce-line-number: #c6c6c6;
}

.active-indent {
	--pce-guide-indent: #ffffff45;
}

/* Tokens */

.token.comment,
.token.prolog,
.token.cdata {
	color: #6272a4;
}

[class*="language-"],
.token.punctuation,
.token.code.keyword {
	color: #f8f8f2;
}

.token.namespace {
	opacity: .7;
}

.token.tag,
.token.operator,
.token.attr-equals,
.token.doctype-tag,
.token.symbol,
.token.unit,
.token.selector,
.token.deleted,
.token.keyword,
.token.quantifier.number,
.token.token.anchor,
.token.regex-flags,
.token.atrule .rule,
.token.url > .content {
	color: #ff79c6;
}

.token.class-name,
.token.maybe-class-name,
.language-css .token.function,
.language-css .token.property,
.language-markdown .url {
	color: #8be9fd;
}

.token.boolean,
.token.number,
.token.color,
.token.entity,
.token.char-set,
.token.keyword-this,
.token.keyword-null,
.token.keyword-undefined,
.language-markdown .token.title {
	color: #bd93f9;
}

.selector .class,
.selector .id,
.token.pseudo-element,
.token.pseudo-class,
.token.attr-name,
.token.builtin,
.token.inserted,
.token.function,
.token.doctype,
.token.code-language,
.token.code.code-snippet {
	color: #50fa7b;
}

.token.variable {
	color: #f8f8f2;
}

.token.regex,
.language-regex,
.token.attr-value,
.token.attr-value > .punctuation,
.token.char,
.token.string,
.token.string-property,
.language-markdown .italic * {
	color: #f1fa8c;
}

.token.regex-delimiter,
.token.char-class .operator {
	color: #ff5555;
}

.token.important,
.token.parameter,
.token.group,
.token.regex .punctuation,
.token.generic,
.token.url:not(.string),
.token.atrule,
.token.bold *,
.token.constant {
	color: #ffb86c;
}

.language-tsx .token.builtin,
.token.char-class .punctuation,
.language-typescript .token.builtin {
	color: #8be9fd;
}

.token.important,
.token.bold {
	font-weight: bold;
}

.token.italic,
.token.parameter,
.token.attr-name,
.doctype .name,
.selector .class,
.token.pseudo-element,
.token.pseudo-class,
.tag > .class-name {
	font-style: italic;
}

.parameter .punctuation {
	font-style: normal;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-6 {
	color: #f8f8f2;
}

.token.bracket-level-1,
.token.bracket-level-7 {
	color: #ff79c6;
}

.token.bracket-level-2,
.token.bracket-level-8 {
	color: #8be9fd;
}

.token.bracket-level-3,
.token.bracket-level-9 {
	color: #50fa7b;
}

.token.bracket-level-4,
.token.bracket-level-10 {
	color: #bd93f9;
}

.token.bracket-level-5,
.token.bracket-level-11 {
	color: #ffb86c;
}

.token.interpolation-punctuation {
	color: #ff79c6;
}

.token.bracket-error {
	color: #ff5555;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #b9b9b9, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #8be9fd4f;
}
